import React, { useEffect, useState } from 'react';
import { Link } from 'gatsby';

import GatsbyImage from '../../Image/GatsbyImage';
import FormControl from './components/FormControl';

import truncateUrl from '../Utilities/truncateUrl';
import formatUrlValue from '../Utilities/formatUrlValue';
import {
  handlePhoneOnChange,
  handleSubmit,
  validateOnChange,
} from './utils/helpers';

import { Container, Form, Button, Footer } from './styles/index.styled';

const DownloadableAssetForm = ({ component, location }) => {
  const [data, setData] = useState({
    email: '',
    firstname: '',
    lastname: '',
    companyname: '',
    companysize: '',
    url: truncateUrl(location?.href),
    phone: '',
    jobtitle: '',
    industry: '',
    industrydetail: '',
    country: '',
    countrycode: '',
    state: '',
  });
  const [validation, setValidation] = useState({
    email: '',
  });

  useEffect(() => {
    const url = formatUrlValue(location);
    setData({ ...data, url: truncateUrl(url) });
  }, []);

  const handleChange = e => {
    if (e.target.name === 'phone') {
      handlePhoneOnChange(e, validation, setValidation, data, setData);
      return;
    }
    setData({ ...data, [e.target.name]: e.target.value });
    validateOnChange(e, e.target.name, validation, setValidation);
  };

  if (!component) return null;

  const {
    image,
    internalName,
    pardotFormHandler,
    downloadableAsset,
  } = component;

  return (
    <Container>
      <GatsbyImage
        src={image?.image?.gatsbyImageData}
        alt={image?.image?.alt}
      />
      <Form
        id="download-form"
        data-zi-mapped-form
        onSubmit={e =>
          handleSubmit(
            e,
            data,
            setData,
            validation,
            setValidation,
            pardotFormHandler,
            internalName,
            downloadableAsset.url
          )
        }
      >
        <FormControl
          id="email"
          type="email"
          label="Email*"
          name="email"
          placeholder="Enter your email"
          required
          autoComplete="email"
          errorMessage={validation.email}
          value={data.email}
          handleChange={handleChange}
        />
        <FormControl
          id="firstname"
          type="text"
          name="firstname"
          placeholder="First Name"
          autoComplete="given-name"
          errorMessage={validation.firstname}
          value={data.firstname}
          handleChange={handleChange}
          hidden
        />
        <FormControl
          id="lastname"
          type="text"
          name="lastname"
          placeholder="Last Name"
          autoComplete="family-name"
          errorMessage={validation.lastname}
          value={data.lastname}
          handleChange={handleChange}
          hidden
        />
        <FormControl
          id="phone"
          type="tel"
          name="phone"
          placeholder="Mobile Number"
          autoComplete="off"
          errorMessage={validation.phone}
          value={data.phone}
          handleChange={handleChange}
          hidden
        />
        <FormControl
          id="companyname"
          type="text"
          name="companyname"
          placeholder="Company Name"
          autoComplete="organization"
          errorMessage={validation.companyname}
          value={data.companyname}
          handleChange={handleChange}
          hidden
        />
        <FormControl
          id="companysize"
          type="number"
          name="companysize"
          placeholder="Number of Employees"
          autoComplete="on"
          errorMessage={validation.companysize}
          value={data.companysize}
          handleChange={handleChange}
          hidden
        />
        <FormControl
          id="jobtitle"
          type="text"
          name="jobtitle"
          placeholder="Job Title"
          autoComplete="on"
          value={data.jobtitle}
          handleChange={handleChange}
          hidden
        />
        <FormControl
          id="industry"
          type="text"
          name="industry"
          placeholder="Industry"
          autoComplete="on"
          value={data.industry}
          handleChange={handleChange}
          hidden
        />
        <FormControl
          id="industrydetail"
          type="text"
          name="industrydetail"
          placeholder="Industry Details"
          autoComplete="on"
          value={data.industrydetail}
          handleChange={handleChange}
          hidden
        />
        <FormControl
          id="country"
          type="text"
          name="country"
          placeholder="Country"
          autoComplete="country"
          value={data.country}
          handleChange={handleChange}
          hidden
        />
        <FormControl
          id="state"
          type="text"
          name="state"
          placeholder="State"
          autoComplete="state"
          value={data.state}
          handleChange={handleChange}
          hidden
        />
        <Footer>
          <Button type="submit">Download Now</Button>
          <div className="use-policy">
            <p>
              By clicking above, you agree to the{' '}
              <Link to="/terms">UpKeep Terms of Use.</Link>
            </p>
          </div>
        </Footer>
      </Form>
    </Container>
  );
};

export default DownloadableAssetForm;
